export default __webpack_public_path__ + "static/media/logo.13b9419f.png";